<template>
    <app-layout>
        <Head>
            <title>Warenkorb</title>
        </Head>

        <template v-slot:overline>
            <translate>jetzt Bestellen</translate>
        </template>

        <template v-slot:headline>
            <translate>Ihr Warenkorb</translate>
        </template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark" class-names="active">
                    <translate>Prüfen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting" class-names="active">
                    <translate>Adresse und Zahlungsart</translate>
                </step>
                <step icon="credit-card-security-protection" class-names="active">
                    <translate>Bezahlen</translate>
                </step>
            </stepper>
        </template>

        <div class="checkout">
            <form @submit.prevent="submit">
                <div class="row">
                    <div class="col col-8">
                        <card>
                            <card-content>
                                <table class="table table--stripped">
                                    <thead>
                                    <tr>
                                        <th class="text-center">
                                            <translate>Pos.</translate>
                                        </th>
                                        <th>
                                            <translate>PF-Nr</translate>
                                        </th>
                                        <th>
                                            <translate>Projekttitle</translate>
                                        </th>
                                        <th class="text-right">
                                            <translate>Stück</translate>
                                        </th>
                                        <th class="text-right">
                                            <translate>Lieferzeit <span>ab Bestellung</span></translate>
                                        </th>
                                        <th class="text-right">
                                            <translate>Lieferdatum <span>Bestellung heute</span></translate>
                                        </th>
                                        <th class="text-right">
                                            <translate>Nettopreis</translate>
                                        </th>
                                        <th class="text-right"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(offer, index) in offers" :key="offer">
                                        <td class="text-center">
                                            {{ index + 1 }}
                                        </td>
                                        <td>{{ offer.ask_for_quote.pfnumber }}</td>
                                        <td>{{ offer.ask_for_quote.project_name }}
                                            <br><small
                                                class="text-medium">{{ offer.ask_for_quote.internal_article_number }}
                                                {{ offer.ask_for_quote.internal_ask_number }}</small>
                                        </td>
                                        <td class="text-right">{{ offer.amount }}</td>
                                        <td class="text-right">{{ offer.delivery_days_client }} <translate>Tage</translate></td>
                                        <td class="text-right">{{ offer.delivery_date }}
                                            <form-input type="hidden"
                                                        v-model="form.delivery_date[offer.ask_for_quote.id]"/>
                                        </td>
                                        <td class="text-right">{{ this.$currency(offer.net_price) }}</td>
                                        <td class="text-right" style="width: 120px;">
                                            <form-link-button :href="offer.route" class="btn--dense"
                                                              icon="document-edit"/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                    <div class="col col-4">
                        <div class="row">
                            <div class="col">
                                <card minify="true">
                                    <card-header>
                                        <card-overline>
                                            <translate>Kasse</translate>
                                        </card-overline>
                                    </card-header>
                                    <card-content>
                                        <div class="checkout--total">
                                            <translate>Summe Netto</translate>
                                            <span class="number">{{ this.$currency(total.net_price) }}</span>
                                            <translate>19% USt.</translate>
                                            <span class="number">{{ this.$currency(total.ust) }}</span>
                                            <strong>
                                                <translate>Gesamtsumme brutto</translate>
                                                <br>
                                                <small class="text-medium">
                                                    <translate>inkl. Versandkosten</translate>
                                                </small>
                                            </strong>
                                            <strong class="number">
                                                {{ this.$currency(total.offer_price) }}
                                            </strong>
                                        </div>
                                    </card-content>
                                </card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <card minify="true">
                                    <card-header>
                                        <card-overline>
                                            <translate>Jetzt bestellen</translate>
                                        </card-overline>
                                    </card-header>
                                    <card-content>
                                        <description-group grid="true">
                                            <description-element :caption="paymentType" :title="this.$gettext('gewählte Zahlungsart')"/>
                                            <description-element :caption="internalOrderNumber"
                                                                 :title="this.$gettext('Ihre Bestellnummer')"/>
                                        </description-group>
                                    </card-content>
                                    <card-content>
                                        <hr>
                                    </card-content>
                                    <card-content>
                                        <form-checkbox id="rate_later" v-model:checked="form.rate_later"
                                                       :option="this.$gettext('Später bewerten')"/>
                                        <form-checkbox id="terms" v-model:checked="form.terms"
                                                       :option="termsOption"
                                                       :error="form.errors.terms"/>

                                        <div class="checkout--sidebar">
                                            <form-actions>
                                                <form-link-button :href="checkoutDelivery"
                                                                  icon="button-arrow-left-circle"
                                                                  icon-before="true"><translate>zurück</translate>
                                                </form-link-button>
                                                <form-button color="secondary" icon="button-arrow-right-circle" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                                    <translate>Jetzt kostenpflichtig bestellen</translate>
                                                </form-button>
                                            </form-actions>
                                        </div>
                                    </card-content>
                                    <card-content>
                                        <p class="body-2">
                                            <translate>Sie werden zur Bezahlung auf die Seite des Paymentanbieters
                                                weitergeleitet.
                                            </translate>
                                        </p>
                                    </card-content>
                                </card>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import Step from '@partfactory/Shared/Stepper/Step';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import {useForm} from '@inertiajs/vue3';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormInput from '@partfactory/Shared/Form/FormInput';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';

export default {
    name: 'Payment',
    components: {
        DescriptionElement,
        DescriptionGroup,
        FormInput,
        FormCheckbox,
        FormLinkButton,
        FormActions, FormButton, CardHeader, CardOverline, CardContent, Card, Step, Stepper, AppLayout
    },
    props: {
        cart: Object,
        askForQuoteAddress: Object,
        clientCountries: Object,
        payment_type: String,
        pp_owner_email: Object,
        rate: Object,
    },
    data() {
        const form = useForm({
            rate_later: this?.rate_later,
            terms: null,
            delivery_date: {},
        });
        return {form};
    },
    setup() {
        let total = {
            net_price: 0,
            ust: 0,
            offer_price: 0,
        };
        return {total};
    },
    computed: {
        checkoutDelivery() {
            return this.$$route('checkout.delivery');
        },
        offers() {
            let offer = Array;
            return Object.keys(this.cart).map((key) => {

                offer[key] = this.cart[key];

                offer[key].ust = offer[key].offer_price - offer[key].net_price;
                offer[key].ust = (Math.round(offer[key].ust * 100) / 100).toFixed(2);

                this.total.net_price += Number(offer[key].net_price);
                this.total.ust += Number(offer[key].ust);
                this.total.offer_price += Number(offer[key].offer_price);

                let delivery_date = '';
                if (this.$moment().isBusinessDay() && !this.$moment().isHoliday()) {
                    delivery_date = this.$moment().add(offer[key].delivery_days_producer, 'days');
                } else {
                    delivery_date = this.$moment().nextBusinessDay().add(offer[key].delivery_days_producer, 'days');
                }
                if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                    delivery_date = delivery_date.nextBusinessDay();
                }

                delivery_date = delivery_date.add((offer[key].delivery_days_client - offer[key].delivery_days_producer), 'days');

                if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                    delivery_date = delivery_date.nextBusinessDay();
                }

                offer[key].delivery_date = delivery_date.format('DD.MM.YYYY');

                this.form.delivery_date[offer[key].ask_for_quote.id] = delivery_date.format('YYYY-MM-DD');

                // offer[key].delivery_date = delivery_date.format('DD.MM.YYYY');

                offer[key].route = this.$$route('component', {'askForQuote': offer[key].ask_for_quote.id});

                return offer[key];
            });
        },
        paymentType() {
            let payment = String;
            switch (this.payment_type) {
                case 'BL_IV':
                    payment = this.$gettext('Rechnung');
                    break;
                case 'CC':
                    payment = this.$gettext('Kreditkarte');
                    break;
                case 'VA':
                    payment = this.$gettext('PayPal Express');
                    break;
                case 'OT_SO':
                    payment = this.$gettext('Sofortüberweisen (Deutschland)');
                    break;
                case 'OT_GP':
                    payment = this.$gettext('Giropay (Deutschland)');
                    break;
            }
            return payment;
        },
        internalOrderNumber() {
            return this.cart[0]?.ask_for_quote?.internal_order_number;
        },
        termsOption() {

            const disclaimer_url = this.$language.current === 'en' ? this.$page.props.urls.disclaimer_en: this.$page.props.urls.disclaimer_de;
            const termsandconditions_url = this.$language.current === 'en' ? this.$page.props.urls.termsandconditions_en: this.$page.props.urls.termsandconditions_de;

            let translated = this.$gettext('Ich akzeptiere die <a href="%{disclaimer}" target="_blank">Datenschutzerklärung</a> und <a href="%{termsandconditions}" target="_blank">AGB</a>.');
            return this.$gettextInterpolate(translated, { disclaimer: disclaimer_url, termsandconditions: termsandconditions_url });
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('checkout.payment.post'), {});
        },
    },
};
</script>
